import { AppBar, Box, Button, Toolbar, Tooltip, useTheme } from "@mui/material";
import {
	DeleteButton,
	DisabledButton,
	EnhancedButtonPrimeReact,
	EnhancedButtonPrimeReactSeverity,
	EnhancedToolTip,
	ResetButton,
	SplitButton,
	SubmitButton,
} from "@websential/cosmic-v20";
import { FC, useEffect, useState } from "react";

import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { IAppState } from "../../../../store/reducers";
import PlaylistAddCheckOutlinedIcon from "@mui/icons-material/PlaylistAddCheckOutlined";
import PrintIcon from "@mui/icons-material/Print";
import { T4SlipService } from "../../../../services/T4SlipService";
import { selectedSlipTypee } from "../T4SlipSetup";
import { selectedT4SummaryReduceEIType } from "../../T4SlipSummaryReducedEISetup";
import { selectedT4SummaryType } from "../../T4SlipSummarySetup";
import { useQuery } from "@tanstack/react-query";
import { useSelector } from "react-redux";

export interface IT4SlipSetupToolbar {
	onResetClicked: () => void;
	onDeleteClicked: () => void;
	onPrintClicked: (printType: string) => void;
	isSubmitting: boolean;
	formMethods: any;
	t4SummaryData: any;
	t4SummaryReduceEIData: any;
	pageTitle: string;
	id: any
}

// const T4_SUMMARY_DATA_QUERY_KEY = "get-t4-summary-data";
// const useGetT4SummaryData = (
//   clientid: string,
//   slipType: string | number,
//   taxYear: number) =>
//   useQuery(
//     [T4_SUMMARY_DATA_QUERY_KEY, clientid, slipType, taxYear],
//     (data) => {
//       return T4SlipService.getT4Summary(clientid, slipType, taxYear);
//     },
//     { refetchOnWindowFocus: false }
//   );

//   const useGetT4SummaryReduceEIData = (
//     clientid: string,
//     slipType: string | number,
//     taxYear: number) =>
//     useQuery(
//       [T4_SUMMARY_DATA_QUERY_KEY, clientid, slipType, taxYear],
//       (data) => {
//         return T4SlipService.getT4SummaryReduceEI(clientid, slipType, taxYear);
//       },
//       { refetchOnWindowFocus: false }
//     );
export const T4SlipSetupToolbar: FC<IT4SlipSetupToolbar> = ({
	onResetClicked,
	onDeleteClicked,
	onPrintClicked,
	isSubmitting = false,
	formMethods,
	t4SummaryData,
	t4SummaryReduceEIData,
	pageTitle,
	id,
}) => {
	const theme = useTheme();
	const subMenuVisibility = useSelector(
		(state: IAppState) => state.drawerAction.subMenuVisibility
	);
	const [subMenuVisibilityState, setSubMenuVisibility] = useState(subMenuVisibility)
	useEffect(() => {
		if (subMenuVisibility) {
			setSubMenuVisibility(subMenuVisibility)
		}
	}, [subMenuVisibility])
	const selectedSlip = formMethods.getValues("selectedSlip");
	return (
		<AppBar
			position="sticky"
			color="default"
			elevation={1}
			sx={{
				backgroundColor: "#F7F7F7",
				paddingBottom: "16px",
				boxShadow: "none",
				zIndex: theme.zIndex.appBar + 1,
				position: "sticky",
				top: subMenuVisibility ? "112px" : "64px",
				// top: "112px",
			}}
		>
			<Toolbar
				sx={{
					paddingTop: { sm: 1.75, md: 1.75, lg: 1.75, xl: 1.75 },
					paddingBottom: { sm: 0, md: 0, lg: 0, xl: 0 },
					paddingLeft: { sm: 0, md: 0, lg: 0, xl: 0 },
					paddingRight: { sm: 0, md: 0, lg: 0, xl: 0 },
					minHeight: { sm: "48px", md: "48px", lg: "48px", xl: "48px" },
					fontWeight: "700",
					display: "flex",
					justifyContent: "space-between",
				}}
			>
				<div style={{ fontSize: "1.5rem", fontWeight: "bold" }}>
					{pageTitle}
				</div>
				<div
					style={{
						display: "flex",
						justifyContent: "center",
						alignItems: "center",
					}}
				>
					{/* <div style={{ display: "contents" }}> */}
					<div>
						{t4SummaryData &&
							t4SummaryData.confirmationCode &&
							t4SummaryData.confirmationCode !== null &&
							t4SummaryReduceEIData &&
							t4SummaryReduceEIData.confirmationCode !== null &&
							selectedSlipTypee === 400 ? (
							<div style={{ cursor: "not-allowed" }}>
								<DisabledButton
									tooltiptitle={
										"Confirmation No. has been enterned in [Complaince -> t4 -> Summary]"
									}
									isDisabled={true}
									buttonLabel={"Submit"}
									icon={<PlaylistAddCheckOutlinedIcon />}
									testId="disableButton"
								/>
							</div>
						) : (
							// <SubmitButton
							// 	label="Submit"
							// 	testId="submit-button"
							// 	loading={isSubmitting}
							// 	icon={<PlaylistAddCheckOutlinedIcon />}
							// />
							<EnhancedButtonPrimeReact
								label="Submit"
								loading={isSubmitting}
								type="submit"
								raised
								severity={EnhancedButtonPrimeReactSeverity.Success}
							/>
						)}
					</div>
					{/* <ResetButton testId="reset-button" onClickHandler={onResetClicked} /> */}
					<EnhancedButtonPrimeReact
						label="Reset"
						raised
						onClickHandler={onResetClicked}
						style={{ marginLeft: "1rem" }}
						severity={EnhancedButtonPrimeReactSeverity.Secondary}
					/>
					<div>
						{t4SummaryData &&
							t4SummaryData.confirmationCode !== null &&
							t4SummaryReduceEIData &&
							t4SummaryReduceEIData.confirmationCode !== null &&
							selectedSlipTypee === 400 ? (
							<div style={{ cursor: "not-allowed", marginLeft: "1rem" }}>
								<DisabledButton
									tooltiptitle={
										"Confirmation No. has been enterned in [Complaince -> t4 -> Summary]"
									}
									isDisabled={true}
									buttonLabel={"Delete"}
									icon={<DeleteOutlineIcon />}
									testId="disableButton"
								// onClick={onchangeTooltip}
								/>
							</div>
						) : selectedSlip && selectedSlip === "create-new" ? (
							<div style={{ cursor: "not-allowed", marginLeft: "1rem" }}>
								<DisabledButton
									tooltiptitle={""}
									isDisabled={true}
									buttonLabel={"Delete"}
									icon={<DeleteOutlineIcon />}
									testId="disableButton"
								// onClick={onchangeTooltip}
								/>
							</div>
						) : (
							// <DeleteButton
							// 	testId="delete-button"
							// 	onClickHandler={onDeleteClicked}
							// />
							<EnhancedButtonPrimeReact
								label="Delete"
								raised
								onClickHandler={onDeleteClicked}
								style={{ marginLeft: "1rem" }}
								severity={EnhancedButtonPrimeReactSeverity.Danger}
							/>
						)}
					</div>
					{/* <div style={{ flexGrow: 1 }} /> */}
					<div style={{ marginLeft: "1rem" }}>
						{selectedSlip && selectedSlip === "create-new" ? (
							<div style={{ cursor: "not-allowed", marginLeft: "1rem" }}>
								<DisabledButton
									tooltiptitle={""}
									isDisabled={true}
									buttonLabel={"Print"}
									icon={<PrintIcon />}
									testId="disableButton"
								// onClick={onchangeTooltip}
								/>
							</div>
						) : !id ? (
							<div style={{ cursor: "not-allowed" }}>
								<DisabledButton
									tooltiptitle={""}
									isDisabled={true}
									buttonLabel={"Print"}
									icon={<PrintIcon />}
									testId="disableButton"
								// onClick={onchangeTooltip}
								/>
							</div>
						) : (
							<Box
								sx={{
									"& .MuiBox-root ": { background: theme.palette.primary.main },
								}}
							>
								<SplitButton
									options={["Employee", "Employer", "CRA"]}
									onClickHandler={onPrintClicked}
									testId="t4-print-button"
									icon={<PrintIcon />}
									listItemsLabel={`Print T4 \n Slip`}

								/>
							</Box>
						)}
						{/* </div> */}
					</div>
				</div>
			</Toolbar>
		</AppBar>
	);
};
